<template>
    <div class="examine-notice-detail">
        <div class="examin-notice-box">
            <div class="widthPC-90 margin-x-auto">
                <div class="fileNo text-right">{{ baseInfo.fileNo }}</div>

                <!-- 项目审批详情表格 -->
                <table class="detail-table" border="1" cellspacing="0" cellpadding="0">
                    <tr>
                        <th colspan="4">项目审批详情</th>
                    </tr>
                    <tr>
                        <td class="font-bold">标题：</td>
                        <td colspan="3">{{ baseInfo.title }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">项目名称：</td>
                        <td>{{ baseInfo.projectName }}</td>
                        <td class="font-bold">项目编号：</td>
                        <td>{{ baseInfo.projectCode }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">审批单位：</td>
                        <td>{{ baseInfo.handleDeptName }}</td>
                        <td class="font-bold">类型：</td>
                        <td>{{ baseInfo.type }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">完成日期：</td>
                        <td>{{ baseInfo.finishDate }}</td>
                        <td class="font-bold">项目状态：</td>
                        <td>{{ baseInfo.stateName || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">抄送状态：</td>
                        <td>{{ baseInfo.copies || '-' }}</td>
                        <td class="font-bold">公开情况：</td>
                        <td>{{ baseInfo.openType || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">投资额：</td>
                        <td>{{ baseInfo.money ? baseInfo.money + baseInfo.moneyUnit : '-' }}</td>
                        <td class="font-bold">建设内容及规模：</td>
                        <td>{{ baseInfo.scaleContent || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">建设单位：</td>
                        <td><span :class="baseInfo.hasContact && curWebsite.type == 3 ? 'active-color' : ''"
                                @click="baseInfo.hasContact && curWebsite.type == 3 && handlerLinkLocal('/contact/detail?id=' + baseInfo.companyName + '&type=2')">{{
                                baseInfo.companyName || '-' }}</span> </td>
                        <td class="font-bold">项目位置：</td>
                        <td>{{ baseInfo.projectAddress || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">工程费用：</td>
                        <td>{{ baseInfo.projectCost ? baseInfo.projectCost + baseInfo.projectCostUnit : '-' }}</td>
                        <td class="font-bold"></td>
                        <td></td>
                    </tr>
                </table>
                <ad :type="2"></ad>

                <!-- 原有内容 -->
                <div class="detail-content" v-html="baseInfo.content"></div>

                <!-- 招投标核准信息 -->
                <div class="detail-content" v-if="tenderData && tenderData.items">
                    <h3 class="section-title">📋 招投标核准信息</h3>

                    <!-- 招标项目表格 -->
                    <el-table :data="tenderData.items" border stripe style="width: 100%; margin-top: 15px;">
                        <el-table-column type="index" label="序号" width="60" align="center" />

                        <el-table-column prop="typeName" label="项目类型" min-width="120" />

                        <el-table-column prop="biddingEstimate" label="招标估算（万元）" min-width="150" align="right">
                            <template slot-scope="scope">
                                <span v-if="scope.row.biddingEstimate" class="amount">
                                    {{ formatMoney(scope.row.biddingEstimate) }}
                                </span>
                                <span v-else class="empty-text">—</span>
                            </template>
                        </el-table-column>

                        <el-table-column label="招标方式" min-width="120" align="center">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.public" type="success" size="small">公开招标</el-tag>
                                <el-tag v-else-if="scope.row.invitation" type="warning" size="small">邀请招标</el-tag>
                                <el-tag v-else-if="scope.row.nonTender" type="info" size="small">不招标</el-tag>
                                <span v-else class="empty-text">—</span>
                            </template>
                        </el-table-column>

                        <el-table-column label="招标范围" min-width="120" align="center">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.scopeAll" type="primary" size="small">全部招标</el-tag>
                                <el-tag v-else-if="scope.row.scopePart" type="warning" size="small">部分招标</el-tag>
                                <span v-else class="empty-text">—</span>
                            </template>
                        </el-table-column>

                        <el-table-column label="组织形式" min-width="120" align="center">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.entrust" type="primary" size="small">委托招标</el-tag>
                                <el-tag v-else-if="scope.row.self" type="warning" size="small">自行招标</el-tag>
                                <span v-else class="empty-text">—</span>
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- 核准意见 -->
                    <div class="opinion-box" v-if="tenderData.opinion">
                        <h4>📝 核准意见</h4>
                        <ul>
                            <li v-for="(item, index) in opinionList" :key="index">{{ item }}</li>
                        </ul>
                    </div>
                </div>
                <!--判断数组长度 -->
                <relatedBy v-if="extend.relatedByProjectCode && extend.relatedByProjectCode.length > 0"
                    :pageTitle="'关联项目'" :pageType="2" :relatedByData="extend.relatedByProjectCode">
                </relatedBy>
                <relatedBy v-if="extend.relatedByCompanyName && extend.relatedByCompanyName.length > 0"
                    :pageTitle="'建设单位（' + baseInfo.companyName + '）关联项目'" :pageType="1"
                    :relatedByData="extend.relatedByCompanyName">
                </relatedBy>
            </div>
        </div>
    </div>
</template>

<script>
import RelatedBy from '../components/relatedBy'
export default {
    components: {
        RelatedBy
    },

    data() {
        return {
            id: this.$route.query.id || null,
            curWebsite: this.$api.getWebsiteType(),
            baseInfo: {
                fileNo: '',
                projectName: '',
                projectCode: '',
                approvalUnit: '',
                type: '',
                title: '',
                completionDate: ''
            },
            extend: {}
        }
    },
    computed: {
        // 解析 tenderJson 字符串为对象
        tenderData() {
            if (!this.baseInfo.tenderJson) return null
            try {
                return JSON.parse(this.baseInfo.tenderJson)
            } catch (e) {
                console.error('tenderJson 解析失败:', e)
                return null
            }
        },
        // 核准意见拆分为列表
        opinionList() {
            if (!this.tenderData || !this.tenderData.opinion) return []
            return this.tenderData.opinion
                .split(/\r?\n/)
                .filter(line => line.trim())
                .map(line => line.replace(/^\d+\./, '').trim())
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            let ajaxUrl = this.$api.common.ExamineNotice.Detail() + '?id=' + this.id;
            this.$axios.get(ajaxUrl).then((res) => {
                console.log('公告数据详情', res);
                if(res.success) {
                    this.baseInfo = res.data || {};
                    this.extend = res.extend || {};
                }else {
                    this.$message.error(res.msg || '获取数据失败');
                }
                this.pageLoading = false;
            }).catch((err) => { });
        },
        // 格式化金额
        formatMoney(value) {
            if (value === null || value === undefined) return '—'
            return value.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        }
    }
}
</script>

<style lang="less" scoped>
.examin-notice-box {
    padding: 20px;
    width: 100%;
    background: #fff;
}

.fileNo {
    font-size: 20px;
    color: #666;
}

.detail-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;

    th {
        background: #f1f8ff;
        text-align: center;
    }

    th,
    td {
        padding: 10px;
        border: 1px solid #eee;
        min-width: 150px;
    }
}

.detail-content {
    margin-top: 20px;
    padding: 20px;
    line-height: 2;
    border: 1px solid #ebf1f5;
    box-shadow: 0 2px 4px #ebf1f5;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 10px;
    border-left: 4px solid #409eff;
    padding-left: 10px;
}

.amount {
    color: #f56c6c;
    font-weight: 600;
    font-family: 'SF Mono', Monaco, monospace;
}

.empty-text {
    color: #c0c4cc;
}

.opinion-box {
    margin-top: 20px;
    padding: 15px;
    background: #f5f7fa;
    border-radius: 4px;

    h4 {
        margin-bottom: 10px;
        color: #303133;
    }

    ul {
        list-style: none;
        padding: 0;

        li {
            padding: 6px 0;
            color: #606266;
            position: relative;
            padding-left: 16px;

            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 12px;
                width: 6px;
                height: 6px;
                background: #409eff;
                border-radius: 50%;
            }
        }
    }
}
</style>